import * as React from 'react'

const style = require('./Dropdown.css')

interface LinkProps {
  children: React.ReactNode;
  to: string;
}

interface Props {
  children: React.ReactNode;
  shown: boolean;
  className?: string;
}

const Separator = () => <div className={style.separator} />

const LinkComponent = ({ to, children }: LinkProps) => (
  <a href={to} className={style.link}>
    <div className={style.linkContent}>{children}</div>
  </a>
)

export class Dropdown extends React.Component<Props> {
  static Separator = Separator
  static Link = LinkComponent

  render() {
    const { shown, className, children } = this.props

    if (!shown) return null

    return (
      <div className={`${style.container} ${className || ''}`}>
        <div className={`${style.wrapper}`}>
          <div className={style.content}>
            <div className={style.arrow} />
            {children}
          </div>
        </div>
      </div>
    )
  }
}
